import { useContext } from "react";
import { InteractionModalContext } from "../context";

/**
 * Hook that retrieves the interaction modal context, throwing if used outside a provider.
 * @returns {IInteractionModalContext} The interaction modal context value.
 */
const useInteractionModalContext = () => {
    const context = useContext(InteractionModalContext);
    if (!context) {
        throw new Error("useInteractionModalContext must be used within an InteractionModalProvider");
    }
    return context;
};

export { useInteractionModalContext };
